<template>
  <div class="empty">
    <ag-icon width="64" height="64">
      <slot />
    </ag-icon>
    <p v-if="filtered">There are no {{ entityLabel }} that meet this criteria. Try updating your filters and search term to find relevant {{ entityLabel }}.</p>
    <p v-else>No {{ entityLabel }} have been added yet.</p>
    <ag-button @click="onAdd" v-if="isAuthenticated">
      Add
    </ag-button>
  </div>
</template>

<script>
  import { mapState } from "vuex";

  export default {
    name: "EmptyList",
    props: {
      entityLabel: {
        type: String,
        required: true
      },
      filtered: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapState("user", ["isAuthenticated"])
    },
    methods: {
      onAdd() {
        this.$emit("add");
      }
    }
  };
</script>

<style scoped lang="scss">
  .empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    margin: 30px 0;

    svg {
      color: $color-gray-medium;
    }

    p {
      margin: 0 0 $gutter 0;
      color: $color-gray;
      text-align: center;
    }

    > * {
      margin: 10px 0;
    }
  }
</style>
